module.exports = "<mat-form-field>\n  <input matInput name=\"{{name}}\" placeholder=\"{{placeholder}}\" [ngModel]=\"value\" (ngModelChange)=\"change($event)\" \n    [readonly]=\"readonly\" maxlength=\"{{maxlength}}\">\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-input/bra-input.component.html
// module id = ../../../../../src/app/componentes/bra-input/bra-input.component.html
// module chunks = main